import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import { IMaskInput } from "react-imask";
import withReactContent from 'sweetalert2-react-content'
import { withRouter } from '../../common/with-router';
import AsyncSelect from 'react-select/async';
import {FaCheck} from "react-icons/fa";
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

class ExamesStatusEdit extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.enviaRegistro = this.enviaRegistro.bind(this);

        this.fileInput = React.createRef();

        this.state = {
            erroLoadRegistro: "",
            exame_status_id: "",
            titulo_pagina: "",
            loading: false,
            nome: '',
            slug: '',
            tipo: '',
            area: '',
            programa_id: "",
            programa_nome: "",
            programas: [],
        };
    }

    componentDidMount() {
        const id = this.props.router.params.id;
    
        if (id) {
            this.setState({
                exame_status_id: id,
                titulo_pagina: 'Editando Exame Status',
                loading: true,
                erroLoadRegistro: ''
            });

            api.get(`/exames/status_motivos/${id}/`)
            .then(response => {
                const dados = response.data;

                let programasSelecionados = [];
                if (Array.isArray(dados.programas_list)) {
                    programasSelecionados = dados.programas_list.map(p => ({
                        value: p.programa_id,
                        label: p.programa__nome || `Programa ${p.id}`
                    }));
                }

                this.setState({
                    erroLoadRegistro: '',
                    nome: dados.nome,
                    slug: dados.slug,
                    tipo: dados.tipo,
                    area: dados.area,
                    programas: programasSelecionados,
                    loading: false
                });
            })
                .catch(error => {
                    let erro_msg = 'Erro ao carregar exame status, tente novamente';
    
                    if (error.response && error.response.status === 500) {
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }
    
                    this.setState({
                        erroLoadRegistro: erro_msg,
                        loading: false
                    });
                });
        } else {
            this.setState({
                exame_status_id: '',
                titulo_pagina: 'Adicionar Exame Status',
                loading: false,
                erroLoadRegistro: '',
            });
        }
    }

    enviaRegistro = (e) => {
        e.preventDefault();

        this.setState({
            loading: true,
            tipoHelper: "",
            cidIdHelper: ""
        });

        //vererifica se é edição ou adição
        const url = (this.state.exame_status_id) ? '/exames/status_motivos/'+this.state.exame_status_id+'/' : '/exames/status_motivos/'
        const metodo = (this.state.exame_status_id) ? 'put' : 'post'

        let payload = {
            nome: this.state.nome,
            slug: this.state.slug,
            tipo: this.state.tipo,
            area: this.state.area,
            programas_relacionados: Array.isArray(this.state.programas) ? this.state.programas.map(p => p.value) : []
        };


        //envia para api
        api({
            method: metodo,
            url: url,
            data: payload,
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.exame_status_id) ? 'Exame Status atualizado com sucesso' : 'Exame Status cadastrado com sucesso';

            MySwal.fire({
                title: 'Sucesso!',
                html: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
            this.setState({
                loading: false,
            })
            
            //redireciona
            if(!this.state.exame_status_id){
                this.props.router.navigate("/status-exames");
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar exame status, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    carregaProgramas = async (inputValue) => {
        try {
            const response = await api.get(`/programas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas:', error);
            return [];
        }
    };

    carregaProgramas2 = async (inputValue) => {
        try {
            const response = await api.get(`/programas/?nome=${inputValue}`);
            const list = response.data && response.data.results ? response.data.results : response.data;
            if (!Array.isArray(list)) return [];

            return list.map(programa => ({
                value: programa.id ?? programa.value,
                label: programa.nome ?? programa.label ?? String(programa.programa_id ?? programa.value)
            }));
        } catch (error) {
            console.error('Erro ao carregar programas:', error);
            return [];
        }
    };

    handleChange = (event, fieldName) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    };

    handleSelectChange = (field, value) => {
        this.setState({ [field]: value });
    };

    handleProgramsChange = (selected) => {
        this.setState({ programas: selected ? selected : [] });
    };

    render(){
        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="dadosExameStatus" id="tabs-exame-status" className="aditus-tabs">
                    <Tab eventKey="dadosExameStatus" title="Dados do Exame Status"> 
                            <Card className="cardDestaque">
                                <Card.Body>                    
                                    <Form onSubmit={this.enviaRegistro}>
                                        <h4>Exame Status</h4>
                                        <Row>
                                            <Col sm={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Nome <span>*</span></Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="nome" 
                                                        value={this.state.nome} 
                                                        required={true}
                                                        onChange={e => this.handleChange(e, 'nome')} 
                                                        placeholder="Nome"
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Slug <span>*</span></Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="slug" 
                                                        value={this.state.slug} 
                                                        required={true}
                                                        onChange={e => this.handleChange(e, 'slug')} 
                                                        placeholder="Slug"
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col sm={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Tipo <span>*</span></Form.Label>
                                                    <Form.Control
                                                        as="select"
                                                        name="tipo"
                                                        value={this.state.tipo}
                                                        required
                                                        onChange={e => this.handleSelectChange('tipo', e.target.value)}
                                                    >
                                                        <option value="">Selecione...</option>
                                                        <option value="status">Status</option>
                                                        <option value="motivo">Motivo</option>
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>

                                            <Col sm={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Área <span>*</span></Form.Label>
                                                    <Form.Control
                                                        as="select"
                                                        name="area"
                                                        value={this.state.area}
                                                        required
                                                        onChange={e => this.handleSelectChange('area', e.target.value)}
                                                    >
                                                        <option value="">Selecione...</option>
                                                        <option value="pedido-exame">Pedido de exames</option>
                                                        <option value="exame">Exame</option>
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                                                                        
                                           <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Programas</Form.Label>
                                                    <AsyncSelect
                                                        isMulti
                                                        cacheOptions
                                                        loadOptions={this.carregaProgramas2}
                                                        defaultOptions
                                                        name="programas"
                                                        placeholder={"Buscar programas..."}
                                                        noOptionsMessage={() => "Nenhum programa encontrado" }
                                                        onChange={this.handleProgramsChange}
                                                        value={this.state.programas}
                                                        styles={{
                                                            option: (provided) => ({
                                                                ...provided,
                                                                fontSize: '12px',
                                                            }),
                                                        }}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>                                                
                                        <Row>
                                            <Col sm={4}>
                                                <Button variant="success" className="btn-sm" onClick={this.enviaRegistro}>
                                                    <FaCheck className="me-1" /> Salvar Exame Status
                                                </Button>&nbsp;&nbsp;
                                            </Col>
                                        </Row>
                                    </Form> 
                                </Card.Body>                
                            </Card>
                    </Tab>
                </Tabs>
            </div>
        )
    }
}

export default withRouter(ExamesStatusEdit);
